export const ROOM_OBJECT_FILTER = "drop-shadow(rgba(0, 0, 0, 0.3) 0 2px 6px)";
